/**
 * Copy helpers for the nearby-place pages, shared by the page and the
 * llms.txt generator so the same fact reads the same way everywhere.
 */

/**
 * The stored distance, made readable.
 *
 * Distances are free text in the admin ("30-40 minutes", "6–8 miles"). One
 * entry was saved as ".02 miles", which rendered as a bare decimal point in
 * the page title. Anything under a tenth of a mile is across the road, which
 * is the fact the owner confirmed for Kualoa Ranch.
 */
export function formatDistanceFromHomes(distance: string | null | undefined): string {
  if (!distance) return "";
  const text = distance.trim().replace(/^\.(\d)/, "0.$1");
  const miles = /^(\d+(?:\.\d+)?)\s*miles?$/i.exec(text);
  if (miles && parseFloat(miles[1]) < 0.1) return "directly across the road";
  return text;
}

/**
 * The page title for a place: the name and the things people search for
 * about it. The distance belongs in the body, not the title, where it read
 * as ".02 miles from Ka'a'awa".
 */
export function attractionPageTitle(attraction: {
  name: string;
  hours?: string | null;
  ticket_price?: string | null;
}): string {
  const parts: string[] = [];
  if (attraction.hours) parts.push("Hours");
  if (attraction.ticket_price) parts.push(/free/i.test(attraction.ticket_price) ? "Admission" : "Tickets");
  parts.push("Getting There from Ka'a'awa");
  const facts = parts.length === 3 ? `${parts[0]}, ${parts[1]} and ${parts[2]}` : parts.join(" and ");
  return `${attraction.name}: ${facts}`;
}

/** Capitalize the first letter, for a phrase that opens a sentence. */
export function sentenceCase(text: string): string {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
}
